const cordinations = [
  {
    name: "A380",
    color: "#422ac785",
    data: [
      { name: "Қашқадарё вилояти Ғузор тумани", lat: 38.63672, lon: 66.214463 },
      {
        name: "Қашқадарё вилояти Ғузор тумани",
        lat: 38.773621,
        lon: 65.843062,
      },
      {
        name: "Қашқадарё вилояти Косон тумани",
        lat: 39.010759,
        lon: 65.633577,
      },
      {
        name: "Қашқадарё вилояти Муборак тумани",
        lat: 39.234653,
        lon: 65.224785,
      },
      {
        name: "Бухоро вилояти Қоровулбозор тумани",
        lat: 39.504513,
        lon: 64.817337,
      },
      {
        name: "Бухоро вилояти Қоровулбозор тумани",
        lat: 39.696265,
        lon: 64.591155,
      },
     
      { name: "Бухоро вилояти Ромитан тумани", lat: 39.919736, lon: 64.281456 },
      { name: "Бухоро вилояти Газли тумани", lat: 40.218208, lon: 63.328164 },
      { name: "Хоразм вилояти", lat: 41.025783, lon: 62.083275 },
      { name: "Қорақалпоғистон Республикаси", lat: 41.439834, lon: 61.151092 },
      {
        name:'Қорақалпоғистон Республикаси',
        lat:41.655483,
        lon:60.788614
      },
      {
        name:"Қорақалпоғистон Республикаси",
        lat:41.993192,
        lon:60.585475
      },
      {

        name:"Қорақалпоғистон Республикаси",
        lat:42.239935,
        lon:60.163157
      },
      {
        name:"Қорақалпоғистон Республикаси",
        lat:42.428767 ,
        lon: 59.679765
      },
     
      {
        name:"Қорақалпоғистон Республикаси",
        lat:42.882922,
        lon:58.939111
      },
      {
        name:"Қорақалпоғистон Республикаси",
        lat:43.358974 ,
        lon:58.149965
      },
      {
        name:"Қорақалпоғистон Республикаси",
        lat:44.052097,
        lon:57.410380
      }
    ],
  },
  {
    name: "M37",
    color: "#45af3b9f",
    data: [
      {
        name: "Самарқанд  вилояти",
        lat: 39.703144,
        lon: 67.003239,
      },
      {
        name: "Самарқанд  вилояти Қарақипчак",
        lat: 39.876402,
        lon: 66.730588,
      },
      {
        name: "Самарқанд  вилояти",
        lat: 39.930431,
        lon: 66.089927,
      },

      {
        name: "Самарқанд  вилояти Кармана тумани",
        lat: 40.147588,
        lon: 65.331857,
      },
      {
        name: "Бухоро  вилояти Ғидувон тумани",
        lat: 40.085312,
        lon: 64.717284,
      },
      {
        name: "Бухоро  вилояти Карвон бозор",
        lat: 39.804804,
        lon: 64.428645,
      },
      {
        name: "",
        lat: 39.546664,
        lon: 63.896687,
      },
    ],
  },
  {
    name: "А378",
    color: "#b1242488",
    data: [
      {
        name: "Самарқанд  вилояти",
        lat: 39.569817,
        lon: 66.974226,
      },
      {
        name: "Самарқанд  вилояти",
        lat: 39.488371,
        lon: 66.479434,
      },
      {
        name: " Қашқадарё вилояти Чироқчи тумани",
        lat: 39.117164,
        lon: 66.134661,
      },
      {
        name: " Қашқадарё вилояти Қарши шаҳар",
        lat: 38.905159,
        lon: 65.820817,
      },
    ],
  },
  {
    name: "A373",
    color: "rgb(255, 145, 0)",
    data: [
      {
        name: "Тошкент вилояти",
        lat: 41.177345,
        lon: 69.328699,
      },
      {
        name: "Тошкент вилояти Оҳангарон тумани",
        lat: 40.922366,
        lon: 69.597841,
      },
      {
        name: "Тошкент вилояти     Ангрен тумани",
        lat: 41.023818,
        lon: 70.129211,
      },
      {
        name: "Наманган вилояти ",
        lat: 41.083787,
        lon: 70.540346,
      },
      {
        name: "Наманган вилояти",
        lat: 40.591008,
        lon: 70.90189,
      },
      {
        name: "Наманган вилояти  ",
        lat: 40.604448,
        lon: 71.485302,
      },
      {
        name: "Наманган вилояти  ",
        lat: 40.731035,
        lon: 72.064218,
      },
      {
        name: "Наманган вилояти  ",
        lat: 40.640368,
        lon: 72.611778,
      },
    ],
  },
  {
    name: "М34",
    color: "pink",
    data: [
      {
        name: "Янгийўл тумани",
        lat: 41.151692,
        lon: 69.106223,
      },
      {
        name: "Сирдарё вилояти",
        lat: 40.611656,
        lon: 68.727706,
      },
      {
        name: "Сирдарё вилояти ",
        lat: 40.253044,
        lon: 68.835744,
      },
    ],
  },
  {
    name: "М39",
    color: "#70AF62",
    data: [
      {
        name: "Тошкент вил",
        lat: 40.916024,
        lon: 68.70731,
      },
      {
        name: "Тошкент вил",
        lat: 39.741502,
        lon: 67.192342,
      },
      {
        name: "Тошкент вил",
        lat: 39.376555,
        lon: 66.994286,
      },
      {
        name: "Тошкент вил",
        lat: 38.583493,
        lon: 66.290983,
      },
      {
        name: "Тошкент вил",
        lat: 37.647064,
        lon: 67.00772,
      },
      {
        name: "Тошкент вил",
        lat: 37.241956,
        lon: 67.249191,
      },
    ],
  },

  {
    name: "А379",
    color: "rgba(68, 123, 206, 0.527)",
    data: [
      {
        name: "Самарқанд вилояти",
        lat: 40.167417,
        lon: 65.321363,
      },
      {
        name: "Навоий вилояти",
        lat: 40.906805,
        lon: 64.753796, // Corrected longitude
      },
      {
        name: "Навоий вилояти",
        lat: 41.597228,
        lon: 64.182703, // Corrected longitude
      },
      {
        name: "Навоий вилояти",
        lat: 42.118048,
        lon: 63.646635,
      },
    ],
  },
  {
    name: "А376",
    color: "grey",
    data: [
      {
        name: "Фарғона   вилояти",
        lat: 40.504494,
        lon: 70.918966,
      },
      {
        name: "Фарғона   вилояти",
        lat: 40.371316,
        lon: 70.462423,
      },
      {
        name: "УЗБ/ТОЖИК чегара",
        lat: 40.180336,
        lon: 69.791414,
      },
      {
        name: "УЗБ/ТОЖИК чегара",
        lat: 40.177477,
        lon: 69.43058,
      },
      {
        name: "Сирдарё вилояти",
        lat: 40.190487,
        lon: 68.708414,
      },
      {
        name: "Жиззах вилояти",
        lat: 40.096069,
        lon: 67.94827,
      },
    ],
  },
];
export default cordinations;
